(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === "object" && typeof module === "object") module.exports = factory(); else if (typeof define === "function" && define.amd) define("iframeAppBiContext", [], factory); else if (typeof exports === "object") exports["iframeAppBiContext"] = factory(); else root["iframeAppBiContext"] = factory();
})(typeof self !== "undefined" ? self : this, function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) {
                return installedModules[moduleId].exports;
            }
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: false,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = true;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            if (!__webpack_require__.o(exports, name)) {
                Object.defineProperty(exports, name, {
                    enumerable: true,
                    get: getter
                });
            }
        };
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
        __webpack_require__.t = function(value, mode) {
            if (mode & 1) value = __webpack_require__(value);
            if (mode & 8) return value;
            if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            if (mode & 2 && typeof value != "string") for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function getDefault() {
                return module["default"];
            } : function getModuleExports() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "https://static.parastorage.com/services/iframe-app-bi-context/1.578.0/";
        __webpack_require__.p = typeof window !== "undefined" && window.__STATICS_BASE_URL__ || __webpack_require__.p;
        return __webpack_require__(__webpack_require__.s = 10);
    }([ function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", function() {
            return METHODS;
        });
        __webpack_require__.d(__webpack_exports__, "c", function() {
            return PROPS_ACCESS;
        });
        __webpack_require__.d(__webpack_exports__, "a", function() {
            return ALLOW_ALL_POLICY;
        });
        var METHODS = {
            policy: "getCurrentConsentPolicy",
            header: "_getConsentPolicyHeader",
            isMethod: true
        };
        var PROPS_ACCESS = {
            policy: "consentPolicy",
            header: "consentPolicyHeader",
            isMethod: false
        };
        var ALLOW_ALL_POLICY = {
            essential: true,
            dataToThirdParty: true,
            advertising: true,
            functional: true,
            analytics: true
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        (function(global) {
            __webpack_require__.d(__webpack_exports__, "a", function() {
                return getConsentPolicyManager;
            });
            var _consts__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
            var globalContext;
            function getGlobalAccessor() {
                [ getGlobalThis, getGlobal, getSelf, getWindow ].forEach(function(globalAccessFunc) {
                    try {
                        if (!globalContext) {
                            globalContext = globalAccessFunc();
                        }
                    } catch (e) {}
                });
                return globalContext;
            }
            function getWindow() {
                return window;
            }
            function getSelf() {
                return self;
            }
            function getGlobal() {
                return global;
            }
            function getGlobalThis() {
                return globalThis;
            }
            function getConsentPolicyManager(env) {
                if (env === void 0) {
                    env = undefined;
                }
                if (env) {
                    globalContext = env;
                }
                if (!globalContext && !env) {
                    globalContext = getGlobalAccessor();
                }
                var consentPolicyManager;
                try {
                    if (typeof globalContext.commonConfig === "object" && globalContext.commonConfig.consentPolicy) {
                        consentPolicyManager = wrapConsentPolicy(globalContext.commonConfig, _consts__WEBPACK_IMPORTED_MODULE_0__["c"]);
                    }
                    if (!consentPolicyManager && typeof globalContext.consentPolicyManager === "object") {
                        consentPolicyManager = wrapConsentPolicy(globalContext.consentPolicyManager, _consts__WEBPACK_IMPORTED_MODULE_0__["b"]);
                    }
                    if (!consentPolicyManager && typeof globalContext.Wix === "object" && typeof globalContext.Wix.Utils === "object" && typeof globalContext.Wix.Utils.getCurrentConsentPolicy === "function") {
                        consentPolicyManager = wrapConsentPolicy(globalContext.Wix.Utils, _consts__WEBPACK_IMPORTED_MODULE_0__["b"]);
                    }
                } catch (e) {}
                return consentPolicyManager;
            }
            function wrapConsentPolicy(accessor, conf) {
                return {
                    getCurrentConsentPolicy: function() {
                        var extractor = accessor[conf.policy];
                        return conf.isMethod ? extractor() : extractor;
                    },
                    _getConsentPolicyHeader: function() {
                        var extractor = accessor[conf.header];
                        return conf.isMethod ? extractor() : extractor;
                    },
                    deleteReference: !conf.isMethod
                };
            }
        }).call(this, __webpack_require__(9));
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var types_1 = __webpack_require__(7);
        exports.isPolicyAllowsBsi = function(policyDetails) {
            return !policyDetails || !policyDetails.policy || policyDetails.policy[types_1.ConsentPolicyCategories.Analytics] && policyDetails.policy[types_1.ConsentPolicyCategories.Functional];
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.validateExternalApi = function(api) {
            var keys = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                keys[_i - 1] = arguments[_i];
            }
            return keys.forEach(function(key) {
                if (!api || typeof api[key] !== "function") {
                    throw new Error("bsiManager: " + key + " must be a function");
                }
            });
        };
        exports.readCookie = function(name) {
            var regex = RegExp("^\\s*" + name + "=\\s*(.*?)\\s*$");
            var cookies = [];
            try {
                cookies = window.document.cookie.split(";");
            } catch (e) {}
            for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
                var cookie = cookies_1[_i];
                var match = cookie.match(regex);
                if (match) {
                    return match[1];
                }
            }
            return null;
        };
        exports.writeCookie = function(name, value, expires, path, domain) {
            var cookie = name + "=" + value + "; expires=" + new Date(expires).toUTCString() + "; path=" + path + "; domain=" + domain + "; SameSite=None; Secure";
            try {
                window.document.cookie = cookie;
            } catch (e) {}
        };
        exports.destroyCookie = function(name, path, domain) {
            exports.writeCookie(name, null, 0, path, domain);
        };
        exports.getNextLocalMidnight = function() {
            return new Date(Date.now() + 24 * 60 * 60 * 1e3).setHours(0, 0, 0, 0);
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var cookie_storage_1 = __webpack_require__(5);
        var config_storage_1 = __webpack_require__(8);
        var utils_1 = __webpack_require__(3);
        var SlaveBsiManager = function() {
            function SlaveBsiManager() {
                this.acitivityListeners = [];
                this.initialized = false;
            }
            SlaveBsiManager.create = function(api, options) {
                return new SlaveBsiManager().init(api, options);
            };
            SlaveBsiManager.prototype.extend = function() {
                var _this = this;
                if (!this.options.enableCookie) {
                    return;
                }
                var ttl = this.cookie.set(this.config.get()).ttl;
                clearTimeout(this.timeout);
                if (ttl) {
                    this.timeout = setTimeout(function() {
                        return _this.extend();
                    }, ttl - 1e3);
                }
            };
            SlaveBsiManager.prototype.getAndNotify = function() {
                this.acitivityListeners.forEach(function(listener) {
                    return listener();
                });
                return this.options.enableCookie ? this.config.get() || this.cookie.get() : this.config.get();
            };
            SlaveBsiManager.prototype.init = function(api, options) {
                var _this = this;
                utils_1.validateExternalApi(api, "getCommonConfig");
                this.api = api;
                this.options = options;
                this.config = new config_storage_1.ConfigStorage(this.api.getConsentPolicy, this.api.getCommonConfig).subscribe(function() {
                    return _this.extend();
                });
                this.cookie = new cookie_storage_1.CookieStorage(this.config, this.api.getCookieReaderWriter);
                this.initialized = true;
                this.extend();
                return this;
            };
            SlaveBsiManager.prototype.destroy = function() {
                clearTimeout(this.timeout);
            };
            SlaveBsiManager.prototype.onActivity = function(listener) {
                if (typeof listener !== "function") {
                    throw new Error("bsiManager: listener must be a function");
                }
                this.acitivityListeners.push(listener);
                return this;
            };
            SlaveBsiManager.prototype.getBsi = function() {
                if (!this.initialized) {
                    throw new Error("bsiManager: please call init() first");
                }
                return this.getAndNotify();
            };
            return SlaveBsiManager;
        }();
        exports.SlaveBsiManager = SlaveBsiManager;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var config_1 = __webpack_require__(6);
        var policy_1 = __webpack_require__(2);
        var utils_1 = __webpack_require__(3);
        var cookieDomain;
        var cookiePath = "/";
        var isWixCom = function() {
            return config_1.WIX_DOMAINS.some(function(domain) {
                return window.document.location.hostname.indexOf(domain) !== -1;
            });
        };
        var getCookieDomain = function() {
            if (!cookieDomain) {
                var hostname = window.document.location.hostname;
                cookieDomain = isWixCom() ? hostname.replace(/^www\./, "") : hostname;
            }
            return cookieDomain;
        };
        var CookieStorage = function() {
            function CookieStorage(configStorage, getCookieReaderWriter) {
                if (getCookieReaderWriter === void 0) {
                    getCookieReaderWriter = function() {
                        return {
                            read: utils_1.readCookie,
                            write: utils_1.writeCookie,
                            destroy: utils_1.destroyCookie
                        };
                    };
                }
                this.configStorage = configStorage;
                this.getCookieReaderWriter = getCookieReaderWriter;
            }
            CookieStorage.prototype.isAllowed = function() {
                if (!policy_1.isPolicyAllowsBsi(this.configStorage.getPolicy())) {
                    this.destroy();
                    return false;
                }
                return true;
            };
            CookieStorage.prototype.get = function() {
                if (!this.isAllowed()) {
                    return null;
                }
                return this.getCookieReaderWriter().read(config_1.COOKIE_NAME);
            };
            CookieStorage.prototype.set = function(bsi) {
                if (!this.isAllowed()) {
                    return {
                        bsi: null,
                        ttl: null
                    };
                }
                var now = Date.now();
                var expires = Math.min(now + config_1.SESSION_DURATION, utils_1.getNextLocalMidnight());
                var domain = getCookieDomain();
                this.getCookieReaderWriter().write(config_1.COOKIE_NAME, "" + bsi, expires, cookiePath, domain);
                return {
                    bsi: bsi,
                    ttl: expires - now
                };
            };
            CookieStorage.prototype.destroy = function() {
                this.getCookieReaderWriter().destroy(config_1.COOKIE_NAME, cookiePath, getCookieDomain());
                try {
                    window.localStorage.removeItem("beatSessionTs");
                    window.localStorage.removeItem("beatSessionId");
                } catch (e) {}
            };
            return CookieStorage;
        }();
        exports.CookieStorage = CookieStorage;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        exports.COOKIE_NAME = "bSession";
        exports.SESSION_DURATION = 30 * 60 * 1e3;
        exports.FREE_SITE_DOMAINS = [ ".wixsite.com", ".editorx.io" ];
        exports.WIX_DOMAINS = [ ".wix.com", ".editorx.com" ];
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var ConsentPolicyCategories;
        (function(ConsentPolicyCategories) {
            ConsentPolicyCategories["Essential"] = "essential";
            ConsentPolicyCategories["Functional"] = "functional";
            ConsentPolicyCategories["Analytics"] = "analytics";
        })(ConsentPolicyCategories = exports.ConsentPolicyCategories || (exports.ConsentPolicyCategories = {}));
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: true
        });
        var policy_1 = __webpack_require__(2);
        var ConfigStorage = function() {
            function ConfigStorage(getConsentPolicy, getCommonConfig) {
                this.getConsentPolicy = getConsentPolicy;
                this.getCommonConfig = getCommonConfig;
            }
            ConfigStorage.prototype.isAllowed = function() {
                if (!policy_1.isPolicyAllowsBsi(this.getPolicy())) {
                    this.destroy();
                    return false;
                }
                return true;
            };
            ConfigStorage.prototype.call = function(method) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var config = this.getCommonConfig();
                return config && typeof config[method] === "function" && config[method].apply(config, args);
            };
            ConfigStorage.prototype.getPolicy = function() {
                var policy = this.call("get", "consentPolicy");
                if (policy) {
                    return {
                        policy: policy
                    };
                }
                return typeof this.getConsentPolicy === "function" ? this.getConsentPolicy() : null;
            };
            ConfigStorage.prototype.get = function() {
                if (!this.isAllowed()) {
                    return null;
                }
                return this.call("get", "bsi") || null;
            };
            ConfigStorage.prototype.set = function(bsi) {
                if (!this.isAllowed()) {
                    return null;
                }
                this.call("set", "bsi", bsi);
                return bsi;
            };
            ConfigStorage.prototype.subscribe = function(handler) {
                var _this = this;
                this.call("subscribe", function() {
                    var bsi = _this.call("get", "bsi");
                    if (bsi !== _this.bsi) {
                        _this.bsi = bsi;
                        handler(bsi);
                    }
                });
                return this;
            };
            ConfigStorage.prototype.destroy = function() {
                this.call("set", "bsi", null);
            };
            return ConfigStorage;
        }();
        exports.ConfigStorage = ConfigStorage;
    }, function(module, exports) {
        var g;
        g = function() {
            return this;
        }();
        try {
            g = g || new Function("return this")();
        } catch (e) {
            if (typeof window === "object") g = window;
        }
        module.exports = g;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var manager_slave = __webpack_require__(4);
        var consent_policy_accessor = __webpack_require__(1);
        var consts = __webpack_require__(0);
        var src_ConsentPolicyAccessor = function() {
            function ConsentPolicyAccessor(env) {
                if (env) {
                    this.env = env;
                }
                this.consentPolicyAccess = Object(consent_policy_accessor["a"])(this.env);
            }
            ConsentPolicyAccessor.prototype.clearReference = function() {
                if (this.consentPolicyAccess && this.consentPolicyAccess.deleteReference) {
                    this.consentPolicyAccess = undefined;
                }
            };
            ConsentPolicyAccessor.prototype.getCurrentConsentPolicy = function() {
                if (!this.consentPolicyAccess) {
                    this.consentPolicyAccess = Object(consent_policy_accessor["a"])(this.env);
                }
                var policyObj = this.consentPolicyAccess && this.consentPolicyAccess.getCurrentConsentPolicy() || consts["a"];
                this.clearReference();
                return policyObj.policy ? policyObj.policy : policyObj;
            };
            ConsentPolicyAccessor.prototype.getConsentPolicyHeader = function(valueOnly) {
                if (valueOnly === void 0) {
                    valueOnly = false;
                }
                if (!this.consentPolicyAccess) {
                    this.consentPolicyAccess = Object(consent_policy_accessor["a"])(this.env);
                }
                var consentPolicyHeaderObj = this.consentPolicyAccess && this.consentPolicyAccess._getConsentPolicyHeader() || {
                    "consent-policy": ""
                };
                this.clearReference();
                return valueOnly ? consentPolicyHeaderObj["consent-policy"] : consentPolicyHeaderObj;
            };
            return ConsentPolicyAccessor;
        }();
        var BsiManagerKey = "__bsiManager";
        var createBsiManager = function(Wix) {
            var Utils = Wix.Utils;
            var policyAccessor = new src_ConsentPolicyAccessor();
            var callSafe = function(fn) {
                var args = [];
                for (var _i = 1; _i < arguments.length; _i++) {
                    args[_i - 1] = arguments[_i];
                }
                var _a;
                return Utils.commonConfig && typeof Utils.commonConfig[fn] === "function" && (_a = Utils.commonConfig)[fn].apply(_a, args);
            };
            return new manager_slave["SlaveBsiManager"]().init({
                getCommonConfig: function() {
                    return {
                        get: function(key) {
                            return callSafe("get", key);
                        },
                        subscribe: function(handler) {
                            return callSafe("onCommonConfigChanged", handler);
                        }
                    };
                },
                getConsentPolicy: function() {
                    return {
                        policy: policyAccessor.getCurrentConsentPolicy()
                    };
                }
            }, {
                enableCookie: true
            });
        };
        var initBsiManager = function() {
            if (typeof window === "undefined" || !window.Wix) {
                return null;
            }
            if (!window[BsiManagerKey]) {
                window[BsiManagerKey] = {
                    manager: createBsiManager(window.Wix),
                    getBsi: function() {
                        var Analytics = window.Wix.Analytics;
                        if (Analytics && typeof Analytics.reportVisitorActivity === "function") {
                            Analytics.reportVisitorActivity();
                        }
                        return this.manager.getBsi();
                    }
                };
            }
            return window[BsiManagerKey];
        };
        __webpack_require__.d(__webpack_exports__, "getBsi", function() {
            return getBsi;
        });
        __webpack_require__.d(__webpack_exports__, "getBiContext", function() {
            return getBiContext;
        });
        var bsiManager = initBsiManager();
        var index_callSafe = function(Wix, fn) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            var _a;
            if (Wix.Utils && typeof Wix.Utils[fn] === "function") {
                return (_a = Wix.Utils)[fn].apply(_a, args);
            }
        };
        var ENRICHERS = {
            _msid: function(Wix) {
                return index_callSafe(Wix, "getInstanceValue", "metaSiteId");
            },
            _appId: function(Wix) {
                return index_callSafe(Wix, "getInstanceValue", "appDefId");
            },
            _instanceId: function(Wix) {
                return index_callSafe(Wix, "getInstanceId");
            },
            _siteOwnerId: function(Wix) {
                return index_callSafe(Wix, "getSiteOwnerId");
            },
            _siteMemberId: function(Wix) {
                return index_callSafe(Wix, "getUid") || "";
            },
            _visitorId: function(Wix) {
                return index_callSafe(Wix, "getInstanceValue", "aid");
            },
            _viewMode: function(Wix) {
                return index_callSafe(Wix, "getViewMode");
            },
            _uuid: {
                enabled: function(Wix) {
                    return index_callSafe(Wix, "getViewMode") === "editor";
                },
                value: function(Wix) {
                    return index_callSafe(Wix, "getUid") || "";
                }
            },
            _bsi: function(Wix) {
                return getBsi(Wix);
            }
        };
        var getBsi = function(Wix) {
            return bsiManager && bsiManager.getBsi(Wix);
        };
        function getBiContext(Wix) {
            if (!Wix) {
                return {};
            }
            return Object.keys(ENRICHERS).reduce(function(res, field) {
                var prop = ENRICHERS[field];
                if (typeof prop === "function") {
                    res[field] = prop(Wix);
                } else if (prop.enabled(Wix)) {
                    res[field] = prop.value(Wix);
                }
                return res;
            }, {});
        }
    } ]);
});

"use strict";

angular.module("wix.common.bi", []).factory("Logger", function() {
    return W.BI.Logger;
}).factory("DomEventHandler", function() {
    return W.BI.DomEventHandler;
}).run([ "biBrowsingSession", function(biBrowsingSession) {
    biBrowsingSession.track();
} ]);

"use strict";

var W = W || {};

W.BI = W.BI || {};

W.BI.ErrorSeverity = {
    RECOVERABLE: 10,
    WARNING: 20,
    ERROR: 30,
    FATAL: 40
};

W.BI.Categories = {
    EDITOR: 1,
    VIEWER: 2,
    TIMEOUTS: 3,
    SERVER: 4
};

W.BI.initialLoadIsReported = false;

W.BI.Logger = function() {
    var globalApi = function() {
        var DefaultBrand = "wix";
        var DefaultCommonConfig = {
            brand: DefaultBrand
        };
        var DefaultConsentPolicy = {
            functional: true,
            analytics: true,
            __default: false
        };
        var BrandToHostMap = {
            wix: "wix",
            editorx: "editorx"
        };
        function getGlobal(cb, defaultValue) {
            defaultValue = defaultValue || null;
            if (typeof self !== "undefined" && self) {
                return cb(self) || defaultValue;
            }
            return defaultValue;
        }
        function getConsentPolicyDetails() {
            return getGlobal(function(g) {
                var context = g.Wix && g.Wix.Utils || g.consentPolicyManager;
                return context && typeof context.getCurrentConsentPolicy === "function" && context.getCurrentConsentPolicy();
            });
        }
        function getCommonConfigApi() {
            return getGlobal(function(g) {
                return g.Wix && g.Wix.Utils && g.Wix.Utils.commonConfig || g.commonConfig;
            });
        }
        function getConfigValue(key, commonConfigApi) {
            if (!commonConfigApi) {
                return;
            }
            if (typeof commonConfigApi.getAll === "function") {
                var config = commonConfigApi.getAll();
                return config && config[key];
            }
            return commonConfigApi[key];
        }
        function getConsentPolicy(consentPolicyDetails) {
            consentPolicyDetails = consentPolicyDetails || getConsentPolicyDetails();
            return consentPolicyDetails && consentPolicyDetails.policy || DefaultConsentPolicy;
        }
        function getCommonConfigValue(key, commonConfigApi) {
            commonConfigApi = commonConfigApi || getCommonConfigApi();
            var res = getConfigValue(key, commonConfigApi);
            return typeof res !== "undefined" ? res : DefaultCommonConfig[key];
        }
        function getBiUrl(brand) {
            brand = brand || DefaultBrand;
            var hostByBrand = BrandToHostMap[brand] || BrandToHostMap[DefaultBrand];
            return "//frog." + hostByBrand + ".com/";
        }
        function getBsi() {
            return getGlobal(function(g) {
                if (g.Wix && g.__bsiManager && typeof g.__bsiManager.getBsi === "function") {
                    return g.__bsiManager.getBsi();
                }
            }, null);
        }
        return {
            getConsentPolicy: getConsentPolicy,
            getCommonConfigValue: getCommonConfigValue,
            getBiUrl: getBiUrl,
            getBsi: getBsi
        };
    }();
    function now() {
        return new Date().getTime();
    }
    function cacheKiller() {
        return "" + now() + cacheKillerCounter++;
    }
    function performanceInMs() {
        var res = window.performance && window.performance.now ? window.performance.now() : -1;
        return Math.round(res);
    }
    var cacheKillerCounter = 0;
    var startTime = now();
    var defaultEventArgs = {
        _: cacheKiller,
        _lv: "2.0.876|L3",
        ms: performanceInMs
    };
    var defaultErrorArgs = {
        _: cacheKiller,
        _lv: "2.0.876|L3",
        ts: function() {
            return now() - startTime;
        },
        cat: W.BI.Categories.VIEWER,
        sev: W.BI.ErrorSeverity.WARNING,
        iss: 1,
        ver: "1"
    };
    var _initOptions = {
        hostName: "frog.wix.com",
        defaultEventArgs: {},
        defaultErrorArgs: {},
        biUrl: "//frog.wix.com/",
        schemaValidators: [],
        adapter: "",
        error: function(str) {
            throw str;
        }
    };
    var EVENT_IDS = {
        ERROR: 10,
        ON_READY: 302,
        ROUTE_CHANGE: 300
    };
    function _extend(dst) {
        for (var i = 1; i < arguments.length; i++) {
            var extending = arguments[i];
            if (extending) {
                for (var key in extending) {
                    dst[key] = extending[key];
                }
            }
        }
        return dst;
    }
    function biLogger(args) {
        var _lastBiUrl = {
            url: undefined,
            assertEmpty: function() {
                if (this.url !== undefined) {
                    throw "last bi is not empty!!!";
                }
            },
            resolve: function() {
                this.callback();
            },
            clear: function() {
                this.url = undefined;
            }
        };
        var _options;
        var fieldParsers = new W.BI.FieldParsers(args.injector);
        if (args.hostName) {
            args.biUrl = "//" + args.hostName + "/";
        }
        _options = _extend({}, _initOptions, args);
        function _log(eventArgs, callback) {
            var _biFieldsRestrictions = {
                src: {
                    type: "number"
                },
                evid: {
                    type: "number"
                }
            };
            var eventParams = _extend({
                _brandId: globalApi.getCommonConfigValue("brand")
            }, defaultEventArgs, _options.defaultEventArgs, eventArgs);
            var bsi = globalApi.getBsi();
            if (bsi) {
                eventParams._bsi = bsi;
            }
            var schemaValidators = _options.schemaValidators || [];
            var validatorsResult = schemaValidators.length > 0 ? schemaValidators.some(function(validator) {
                return validator.match(eventParams) && (validator.execute(eventParams) || true);
            }) : true;
            if (!validatorsResult) {
                throw new Error("No validator accepted the event");
            }
            if (_validateBiEventArgs(eventParams, [ "evid" ], _biFieldsRestrictions)) {
                _sendBiEvent(eventParams, callback);
            }
        }
        function _error(errorArgs, callback) {
            var _requiredErrorFields = [ "evid", "cat", "iss", "sev", "errc", "ver" ];
            var _errorFieldsRestrictions = {
                src: {
                    type: "number"
                },
                evid: {
                    type: "number",
                    values: [ EVENT_IDS.ERROR ]
                },
                cat: {
                    type: "number",
                    values: [ W.BI.Categories.EDITOR, W.BI.Categories.VIEWER, W.BI.Categories.TIMEOUTS, W.BI.Categories.SERVER ]
                },
                iss: {
                    type: "number"
                },
                sev: {
                    type: "number",
                    values: [ W.BI.ErrorSeverity.RECOVERABLE, W.BI.ErrorSeverity.WARNING, W.BI.ErrorSeverity.ERROR, W.BI.ErrorSeverity.FATAL ]
                },
                errc: {
                    type: "number"
                },
                httpc: {
                    type: "number"
                },
                ver: {
                    type: "string",
                    maxLength: 16
                },
                errscp: {
                    type: "string",
                    subStr: 64
                },
                trgt: {
                    type: "string",
                    subStr: 64
                },
                gsi: {
                    type: "string",
                    length: 36
                },
                ts: {
                    type: "number"
                },
                uid: {
                    type: "number"
                },
                ut: {
                    type: "string",
                    maxLength: 16
                },
                did: {
                    type: "string",
                    maxLength: 36
                },
                cid: {
                    type: "string",
                    length: 36
                },
                lng: {
                    type: "string",
                    maxLength: 5
                },
                dsc: {
                    type: "string",
                    subStr: 512
                }
            };
            var errorParams = _extend({}, defaultErrorArgs, _options.defaultErrorArgs, errorArgs, {
                evid: EVENT_IDS.ERROR
            });
            if (_validateBiEventArgs(errorParams, _requiredErrorFields, _errorFieldsRestrictions)) {
                _sendBiEvent(errorParams, callback);
            }
        }
        function _reportOnReady(viewName, eventArgs, callback) {
            var _onReadyFieldsRestrictions = {
                view: {
                    type: "string"
                }
            };
            var eventParams = _extend({}, eventArgs, {
                evid: EVENT_IDS.ON_READY,
                view: viewName
            });
            if (_validateBiEventArgs(eventParams, [ "view" ], _onReadyFieldsRestrictions)) {
                _log(eventParams, callback);
            }
        }
        function _reportRouteChange(viewName, eventArgs, callback) {
            var _routeChangeFieldsRestrictions = {
                view: {
                    type: "string"
                }
            };
            var eventParams = _extend({}, eventArgs, {
                evid: EVENT_IDS.ROUTE_CHANGE,
                view: viewName
            });
            if (_validateBiEventArgs(eventParams, [ "view" ], _routeChangeFieldsRestrictions)) {
                _log(eventParams, callback);
            }
        }
        function _validateBiEventArgs(eventArgs, requiredArgs, restrictions) {
            var missingRequiredArgs = requiredArgs.slice(0);
            for (var key in eventArgs) {
                var currentRestrictions = restrictions[key] || {};
                eventArgs[key] = fieldParsers.parse(eventArgs[key], currentRestrictions);
                if (!fieldParsers.valid(eventArgs[key], currentRestrictions)) {
                    _options.error("Bad event param (key: " + key + ", value: " + eventArgs[key] + ")");
                    return;
                }
                var missingIndex;
                if ((missingIndex = missingRequiredArgs.indexOf(key)) > -1) {
                    missingRequiredArgs.splice(missingIndex, 1);
                }
            }
            if (missingRequiredArgs.length > 0) {
                _options.error("Missing required params: " + missingRequiredArgs.join(", "));
                return false;
            }
            return true;
        }
        function _addUrlParams(url, params) {
            var delimiter = url.match(/\?./) ? "&" : "?";
            return url.replace(/\?$/, "") + delimiter + Object.keys(params).filter(function(key) {
                return !_options.removeUndefinedValues || params[key] !== undefined;
            }).map(function(key) {
                return [ encodeURIComponent(key), "=", encodeURIComponent(params[key]) ].join("");
            }).join("&");
        }
        function _sendPixel(url, image, onComplete) {
            var onFinish = function() {
                onComplete("pixel");
            };
            var biImage = image || new Image(0, 0);
            biImage.onload = onFinish;
            biImage.onerror = onFinish;
            biImage.src = url;
        }
        function _sendBeacon(url, onComplete) {
            if (!window.navigator || !window.navigator.sendBeacon) {
                return false;
            }
            return window.navigator.sendBeacon(url) && setTimeout(function() {
                onComplete("beacon");
            }, 0);
        }
        function encodePolicyValue(policy, key) {
            if (!policy) {
                return 1;
            }
            if (typeof policy[key] === "boolean") {
                return policy[key] ? 1 : 0;
            }
            return policy[key];
        }
        function _sendBiEvent(eventArgs, callback) {
            var policy = globalApi.getConsentPolicy();
            if (policy && (policy.functional === false || policy.analytics === false)) {
                return;
            }
            var biUrl = args.hostName || args.biUrl ? _options.biUrl : globalApi.getBiUrl(globalApi.getCommonConfigValue("brand"));
            biUrl = biUrl || "//frog.wix.com/";
            var frogAdapter = eventArgs.adapter || _options.adapter;
            delete eventArgs.adapter;
            eventArgs._isca = encodePolicyValue(policy, "analytics");
            eventArgs._iscf = encodePolicyValue(policy, "functional");
            eventArgs._ispd = policy.__default ? 1 : 0;
            eventArgs._ise = 0;
            var url = _addUrlParams(biUrl + frogAdapter, eventArgs);
            var onComplete = callback || function() {};
            if (!W.BI.DryRun) {
                if (!_options.useBeacon || !_sendBeacon(url, onComplete)) {
                    _sendPixel(url, _options.image, onComplete);
                }
            } else {
                setTimeout(onComplete, 0);
            }
            _lastBiUrl.url = url;
            _lastBiUrl.callback = callback;
        }
        return {
            log: _log,
            reportOnReady: _reportOnReady,
            reportRouteChange: _reportRouteChange,
            error: _error,
            getLastBiUrl: function() {
                return _lastBiUrl;
            }
        };
    }
    return biLogger;
}();

"use strict";

var W = W || {};

W.BI = W.BI || {};

W.BI.DomEventHandler = function() {
    var _wixBiAttributeSelector = "wix-bi", _wixBiArgsAttribute = "wix-bi-args", _initOptions = {
        eventMap: {},
        errorMap: {},
        error: function(str) {
            throw str;
        }
    };
    function _extend(dst) {
        for (var i = 1; i < arguments.length; i++) {
            var extending = arguments[i];
            if (extending) {
                for (var key in extending) {
                    dst[key] = extending[key];
                }
            }
        }
        return dst;
    }
    function eventHandler(biLogger, args) {
        var _options;
        var _biLogger = biLogger;
        _options = _extend({}, _initOptions, args);
        function _safeGetEventParams(eventName, eventMap, explicitParams) {
            var params;
            if (!eventMap || !eventMap[eventName]) {
                _options.error("Invalid event name");
                params = {};
            } else {
                params = eventMap[eventName];
            }
            return _extend({}, params, explicitParams);
        }
        function _log(eventName, eventArgs, callback) {
            var eventParams = _safeGetEventParams(eventName, _options.eventMap, eventArgs);
            _biLogger.log(eventParams, callback);
        }
        function _error(errorName, errorArgs, callback) {
            var errorParams = _safeGetEventParams(errorName, _options.errorMap, errorArgs);
            _biLogger.error(errorParams, callback);
        }
        function _getAttr(element, name) {
            for (var i = 0; i < element.attributes.length; i++) {
                if (element.attributes[i].name === name) {
                    return element.attributes[i].value;
                }
            }
        }
        function _handleTriggeredBiEvent(event) {
            var eventName = _getAttr(event.target, _wixBiAttributeSelector);
            if (eventName) {
                var eventArgsStr = _getAttr(event.target, _wixBiArgsAttribute);
                var eventArgs = eventArgsStr ? eval("eventArgs = " + eventArgsStr) : {};
                _log(eventName, eventArgs);
            }
        }
        function _bind() {
            document.body.addEventListener("click", _handleTriggeredBiEvent);
        }
        function _unbind() {
            document.body.removeEventListener("click", _handleTriggeredBiEvent);
        }
        return {
            bind: _bind,
            unbind: _unbind,
            log: _log,
            error: _error
        };
    }
    return eventHandler;
}();

"use strict";

var W = W || {};

W.BI = W.BI || {};

W.BI.FieldParsers = function($injector) {
    var validators = {
        length: function(val, length) {
            return val && val.length !== undefined && val.length === length;
        },
        maxLength: function(val, maxLength) {
            return val && val.length !== undefined && val.length <= maxLength;
        },
        values: function(val, values) {
            return values && values.indexOf(val) !== -1;
        },
        type: function(val, type) {
            return val && typeof val === type;
        }
    };
    var parsers = {
        subStr: function(val, length) {
            if (val && val.substr) {
                return val.substr(0, Math.min(val.length, length));
            }
            return val;
        }
    };
    this.valid = function(value, restrictions) {
        for (var key in restrictions) {
            if (validators[key] && !validators[key](value, restrictions[key])) {
                return false;
            }
        }
        return true;
    };
    this.parse = function(value, restrictions) {
        if (typeof value === "function") {
            value = $injector ? $injector.invoke(value) : value();
        }
        for (var key in restrictions) {
            value = parsers[key] ? parsers[key](value, restrictions[key]) : value;
        }
        return value;
    };
};

"use strict";

angular.module("wix.common.bi").directive("wixBi", [ "domBiLogger", "$window", function(domBiLogger, $window) {
    function convertAttrToConst(attr) {
        return attr.replace(/-/g, "_").toUpperCase();
    }
    return {
        restrict: "A",
        priority: 1,
        link: {
            pre: function(scope, element, attr) {
                var eventType = attr.wixBiEvent || "click";
                element.bind(eventType, function(ev) {
                    var eventName = convertAttrToConst(attr.wixBi);
                    var eventArgs = scope.$eval(attr.wixBiArgs) || {};
                    if (eventType === "click" && ev.target.href && attr.delayHref !== undefined) {
                        var href = ev.target.href;
                        ev.preventDefault();
                        domBiLogger.log(eventName, eventArgs, function() {
                            $window.location = href;
                        });
                    } else {
                        domBiLogger.log(eventName, eventArgs);
                    }
                });
            }
        }
    };
} ]);

"use strict";

angular.module("wix.common.bi").provider("biLogger", [ "recursiveExtend", function(recursiveExtend) {
    var _config = {
        eventMap: {}
    };
    this.setConfig = function(config) {
        recursiveExtend(_config, config);
    };
    this.$get = [ "Logger", "$injector", function(Logger, $injector) {
        function buildAuthorizationContext() {
            var authorizationContext = {};
            authorizationContext.ownerId = function(permissionsManager) {
                return permissionsManager.$$getOwnerId();
            };
            authorizationContext.ownerId.$inject = [ "permissionsManager" ];
            authorizationContext.roles = function(permissionsManager) {
                return permissionsManager.$$getRoles().join(",");
            };
            authorizationContext.roles.$inject = [ "permissionsManager" ];
            return authorizationContext;
        }
        _config.injector = $injector;
        if ($injector.has("permissionsManager")) {
            var authorizationContext = buildAuthorizationContext();
            _config.defaultEventArgs = angular.extend({}, _config.defaultEventArgs, authorizationContext);
            _config.defaultErrorArgs = angular.extend({}, _config.defaultErrorArgs, authorizationContext);
        }
        return angular.extend(new Logger(_config), {
            getConfig: function() {
                return _config;
            }
        });
    } ];
    this.$get.$inject = [ "Logger", "$injector" ];
} ]);

"use strict";

angular.module("wix.common.bi").provider("domBiLogger", [ "recursiveExtend", function(recursiveExtend) {
    var _config = {
        eventMap: {}
    };
    this.setConfig = function(config) {
        recursiveExtend(_config, config);
    };
    this.$get = [ "biLogger", "DomEventHandler", function(biLogger, DomEventHandler) {
        return angular.extend(new DomEventHandler(biLogger, _config), {
            getConfig: function() {
                return _config;
            }
        });
    } ];
    this.$get.$inject = [ "biLogger", "DomEventHandler" ];
} ]);

"use strict";

angular.module("wix.common.bi").constant("recursiveExtend", function() {
    function isObject(v) {
        return v !== null && typeof v === "object" && v.constructor !== Array;
    }
    function applyModifications(conf, partial) {
        for (var k in partial) {
            if (partial.hasOwnProperty(k)) {
                if (isObject(partial[k])) {
                    conf[k] = conf[k] || {};
                    applyModifications(conf[k], partial[k]);
                } else {
                    conf[k] = partial[k];
                }
            }
        }
    }
    return applyModifications;
}());

"use strict";

(function() {
    function provideBrowsingContext(cb) {
        if (typeof window !== "undefined" && window) {
            try {
                return window.top === window.self ? cb ? cb(window) : window : null;
            } catch (e) {
                return null;
            }
        }
        return null;
    }
    function hook(obj, fnName, _hook) {
        if (!obj || !obj[fnName]) {
            return;
        }
        var original = obj[fnName];
        obj[fnName] = function() {
            _hook.apply(null, arguments);
            return original.apply(obj, arguments);
        };
    }
    function guid() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
            var r = Math.random() * 16 | 0;
            var v = c === "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }
    angular.module("wix.common.bi").provider("biBrowsingSession", function() {
        var IS_TRACKING = "__isTrackingBiBrowsingSession__";
        var ENDPOINT = "p";
        var SOURCE = 19;
        var EVID = 3;
        var hostName;
        this.setHost = function(host) {
            hostName = host;
        };
        this.$get = [ "$window", "Logger", function($window, Logger) {
            var logger = new Logger({
                hostName: hostName,
                adapter: ENDPOINT,
                useBeacon: true,
                defaultEventArgs: {
                    src: SOURCE,
                    evid: EVID,
                    vsi: guid()
                }
            });
            function getDesktopSize(window) {
                var width = window.screen && window.screen.width || 0;
                var height = window.screen && window.screen.height || 0;
                return [ width, height ].join("x");
            }
            function getWindowSize(window) {
                var width = 0;
                var height = 0;
                if (window.innerWidth) {
                    width = window.innerWidth;
                    height = window.innerHeight;
                } else if (window.document) {
                    if (window.document.documentElement && window.document.documentElement.clientWidth) {
                        width = window.document.documentElement.clientWidth;
                        height = window.document.documentElement.clientHeight;
                    } else if (window.document.body && window.document.body.clientWidth) {
                        width = window.document.body.clientWidth;
                        height = window.document.body.clientHeight;
                    }
                }
                return [ width, height ].join("x");
            }
            function onLoad(cb) {
                provideBrowsingContext(function(window) {
                    cb(window.location.href);
                });
            }
            function onPushState(cb) {
                provideBrowsingContext(function(window) {
                    [ "pushState", "replaceState" ].forEach(function(fnName) {
                        hook(window.history, fnName, function(_, __, url) {
                            cb(url);
                        });
                    });
                });
            }
            function onPopState(cb) {
                provideBrowsingContext(function(window) {
                    window.addEventListener("popstate", function() {
                        cb(window.location.href);
                    });
                });
            }
            function listen(cb) {
                var fromUrl = window.document.referrer;
                [ onLoad, onPushState, onPopState ].forEach(function(event) {
                    event(function(toUrl) {
                        cb(fromUrl, toUrl);
                        fromUrl = toUrl;
                    });
                });
            }
            function shouldTrack() {
                return provideBrowsingContext(function(window) {
                    return window && !window[IS_TRACKING];
                });
            }
            function setIsTracking() {
                provideBrowsingContext(function(window) {
                    window[IS_TRACKING] = true;
                });
            }
            function track() {
                if (!shouldTrack()) {
                    return;
                }
                setIsTracking();
                var firstInSession = 1;
                listen(function(fromUrl, toUrl) {
                    var screen = provideBrowsingContext(function(window) {
                        return {
                            sr: getDesktopSize(window),
                            wr: getWindowSize(window)
                        };
                    });
                    logger.log({
                        from: fromUrl,
                        to: toUrl,
                        fis: firstInSession,
                        sr: screen.sr,
                        wr: screen.wr
                    });
                    firstInSession = 0;
                });
            }
            return {
                track: track,
                logger: logger
            };
        } ];
        this.$get.$inject = [ "$window", "Logger" ];
    });
})();

"use strict";

angular.module("wix.common.bi").value("nowWrapper", function() {
    return Date.now();
}).provider("wixBiLogger", [ "biLoggerProvider", "domBiLoggerProvider", "biBrowsingSessionProvider", function(biLoggerProvider, domBiLoggerProvider, biBrowsingSessionProvider) {
    this.setConfig = function(config) {
        biLoggerProvider.setConfig(config);
        domBiLoggerProvider.setConfig(config);
        biBrowsingSessionProvider.setHost(config.hostName);
    };
    this.$get = [ "biLogger", "domBiLogger", "$q", "$rootScope", "$window", "$parse", "nowWrapper", function(biLogger, domBiLogger, $q, $rootScope, $window, $parse, nowWrapper) {
        var _config = angular.extend({}, biLogger.getConfig(), domBiLogger.getConfig());
        function makeCb(defer) {
            return function() {
                if ($rootScope.$$phase) {
                    defer.resolve();
                } else {
                    $rootScope.$apply(function() {
                        defer.resolve();
                    });
                }
            };
        }
        function getReducedMap(map) {
            return Object.keys(_config[map] || []).reduce(function(prev, key) {
                prev[key] = key;
                return prev;
            }, {});
        }
        function isNewRelicDefined() {
            return typeof $window.NREUM !== "undefined";
        }
        return {
            log: function(eventName, eventArgs) {
                var defer = $q.defer();
                if (typeof eventName === "string" || !eventName) {
                    domBiLogger.log(eventName, eventArgs, makeCb(defer));
                } else {
                    biLogger.log(eventName, makeCb(defer));
                }
                return defer.promise;
            },
            error: function(eventName, eventArgs) {
                var defer = $q.defer();
                if (typeof eventName === "string") {
                    domBiLogger.error(eventName, eventArgs, makeCb(defer));
                } else {
                    biLogger.error(eventName, makeCb(defer));
                }
                return defer.promise;
            },
            reportOnReady: function(viewName, eventArgs) {
                var defer = $q.defer();
                if (!W.BI.initialLoadIsReported) {
                    if (isNewRelicDefined()) {
                        $window.NREUM.finished();
                    }
                    if (eventArgs === undefined) {
                        eventArgs = {};
                    }
                    var startTime = $parse("performance.timing.navigationStart")($window);
                    if (startTime) {
                        eventArgs.loading_time = nowWrapper() - startTime;
                    }
                    eventArgs.initial_load = true;
                    W.BI.initialLoadIsReported = true;
                }
                biLogger.reportOnReady(viewName, eventArgs, makeCb(defer));
                return defer.promise;
            },
            reportRouteChange: function(viewName, eventArgs) {
                var defer = $q.defer();
                biLogger.reportRouteChange(viewName, eventArgs, makeCb(defer));
                return defer.promise;
            },
            getLastBiUrl: function() {
                return biLogger.getLastBiUrl();
            },
            events: getReducedMap("eventMap"),
            errors: getReducedMap("errorMap"),
            getConfig: function() {
                return angular.extend({}, biLogger.getConfig(), domBiLogger.getConfig());
            }
        };
    } ];
    this.$get.$inject = [ "biLogger", "domBiLogger", "$q", "$rootScope", "$window", "$parse", "nowWrapper" ];
} ]);
//# sourceMappingURL=wix-bi-angular.js.map
/*** EXPORTS FROM exports-loader ***/
export {
  W
};
